import {Validators} from '@angular/forms';

import {NameValidator, OnlyLatinValidator, WhitespaceValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../app/shared/enums';
import {PhoneAutocompleteValueInterface} from '../../app/shared/widgets/phone-autocomplete';
import {BaseControl, PhoneAutocompleteControl, SelectControl} from '../../app/shared/classes';

export const ClientUsersFormFirstNameSelector = 'userFirstName';
export const ClientUsersFormMiddleNameSelector = 'userMiddleName';
export const ClientUsersFormLastNameSelector = 'userLastName';
export const ClientUsersFormStatusSelector = 'userStatus';
export const ClientUsersPhoneNumberSelector = 'userPhone';

export const ClientUsersNameMinLength = 3;

export const ClientUsersFormControls = (): BaseControl<string | number | PhoneAutocompleteValueInterface>[] => {
    return [
        new BaseControl({
            name: ClientUsersFormFirstNameSelector,
            value: '',
            placeholder: 'First name',
            validators: [WhitespaceValidator(), NameValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersFormMiddleNameSelector,
            value: '',
            placeholder: 'Middle name',
            validators: [NameValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: ClientUsersFormLastNameSelector,
            value: '',
            placeholder: 'Last name',
            validators: [WhitespaceValidator(), NameValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new SelectControl({
            name: ClientUsersFormStatusSelector,
            value: '',
            placeholder: 'Status',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new PhoneAutocompleteControl({
            name: ClientUsersPhoneNumberSelector,
            value: null,
            placeholder: 'Phone',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.PhoneAutocomplete,
            countries: [],
            floatingLabelNever: true
        }),
    ];
};


